import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../components/Breadcrumb";
import CounselorCarousel from "./CounselorCarousel";

const CounselorCarouselLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Counselor Carousel" />
      <CounselorCarousel />
    </MasterLayout>
  );
};

export default CounselorCarouselLayout;
